import * as React from 'react';
import classNames from 'classnames';

import { getDisplayDateRange } from 'utils/date';
import { __t, applyTranslations } from 'utils/language';

import './campaign-zalando-outfit.i18n.json';

applyTranslations(require('./campaign-zalando-outfit.i18n.json'));

import { CcmCampaignStatuses } from 'modules/campaigns/components/ccm/create/utils/ccm-outfits-statuses';

type Props = {
  startDate: string,
  endDate: string,
  statusToRender: CcmCampaignStatuses
}

const msgKey = 'campaign_zalando_outfit';

const OutfitTimeline = ({ startDate, endDate, statusToRender }: Props) => {
  const statusClasses = classNames('campaign-zalando-outfit__timeline-card-item', {
    [`campaign-zalando-outfit__timeline--${statusToRender.replace('_', '-')}-status`]: statusToRender
  });

  const dateClasses = classNames('campaign-zalando-outfit__timeline-card-item', {
    'campaign-zalando-outfit__timeline-card-item--with-bold': statusToRender != 'revoked'
  });

  return (
    <div className="campaign-zalando-outfit__timeline">
      <div className={dateClasses}>
        {getDisplayDateRange(startDate, endDate)}
      </div>
      <div className="campaign-zalando-outfit__timeline-card-item">
        {__t(`${msgKey}.content_go_live`)}
      </div>
      <div className={statusClasses}>
        {__t(`${msgKey}.statuses.${statusToRender}`)}
      </div>
    </div>
  );
};

export default OutfitTimeline;
